import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const sized = (url) => (url?.includes('cloudinary.com') ? url.replace('/upload/', '/upload/w_500,q_auto,f_auto/') : url);

export const CustomerStrip = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const p = await (await fetch(`${API}/api/customer-photos`)).json();
        if (p.photos?.length) {
          setItems(p.photos.slice(0, 20).map((x) => ({ id: x.id, src: sized(x.url), alt: 'Client Entrepôt Auto Montréal' })));
          return;
        }
        const d = await (await fetch(`${API}/api/vehicles/recent-deliveries?days=45&limit=20&min_count=12`)).json();
        setItems((d.vehicles || []).filter((v) => !v.uses_placeholder).map((v) => {
          const img = v.images?.[0];
          return { id: v.id, src: sized(typeof img === 'string' ? img : img?.url), alt: `${v.year} ${v.make} ${v.model}` };
        }).filter((x) => x.src && !x.src.includes('/placeholders/')));
      } catch { /* strip stays hidden */ }
    })();
  }, []);

  if (items.length < 3) return null;
  const loop = [...items, ...items];
  return (
    <div className="mt-12" data-testid="homepage-customer-strip">
      <div className="flex items-center justify-between gap-4 mb-5 max-w-7xl mx-auto px-4">
        <h3 className="text-base md:text-lg font-semibold text-white flex items-center gap-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          <span className="h-px w-8 bg-[#3b82f6]" />
          {t('recentDeliveries.photosSubtitle')}
        </h3>
        <Link to="/nos-livraisons" className="inline-flex items-center gap-1.5 text-sm font-medium text-[#3b82f6] hover:text-blue-700" data-testid="homepage-customer-strip-see-all">
          {t('recentDeliveries.seeAll')} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="relative overflow-hidden group" style={{ maskImage: 'linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent)' }}>
        <div className="flex gap-4 w-max group-hover:[animation-play-state:paused]" style={{ animation: `stripScroll ${items.length * 4}s linear infinite` }}>
          {loop.map((it, i) => (
            <Link key={`${it.id}-${i}`} to="/nos-livraisons" className="block flex-shrink-0 w-56 md:w-72 aspect-[4/3] rounded-xl overflow-hidden bg-slate-800 border border-white/10" aria-hidden={i >= items.length} tabIndex={i >= items.length ? -1 : 0} data-testid={i < items.length ? `customer-strip-item-${it.id}` : undefined}>
              <img src={it.src} alt={it.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
